import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import CKEditor from "react-ckeditor-component";
import $ from 'jquery';
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class ViewChat extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            note_history: [],
            notes: [],
            chat_transcript: [],
            tags: [],
            week: '',
            owner_name: '',
            formatted_owners: [],
            note: '',
            owners: [],
            errors: {},
            apiUrl: this.decryptconfigdata('apiUrl'),
            userEmail: has_local_data ? localdata.user_email : '',
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
        };
        this.AddNote = this.AddNote.bind(this);
        this.ckOnChange1 = this.ckOnChange1.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    ckOnChange1(evt) {
        var ckContent = evt.editor.getData();
        if (this.state.note.toLowerCase() != ckContent.toLowerCase()) {
            this.setState({
                note: ckContent
            })
            var obj = this;
            setTimeout(function () {
                ckContent = ckContent.replace(/<\/p>$/, ""); //remove last </p>
                var nameRegex = /@[a-zA-Z]+$/;
                var matches = ckContent.match(nameRegex); //select characters having @
                if (matches && matches.length > 0) {
                    var indx = matches['index'];
                    var query = matches[0].replace('@', '');
                    if (query) {
                        var result = [];
                        var filterObj = obj.state.owners.filter(function (e) {
                            if (e.name.toLowerCase().includes(query.toLowerCase())) {
                                result.push(e.name);
                            }
                        });
                        var mtchitems = '';
                        if (result.length > 0) {
                            for (var i in result) {
                                mtchitems += '<li class="auto-suggest-li" style="padding:5px;cursor:pointer;background:#ccc;margin-bottom:1px;" >' + result[i] + '</li>';
                                if (i == result.length - 1) {
                                    mtchitems = '<ul style="list-style:none" class="auto-suggest-ul">' + mtchitems + '</ul>';
                                    document.getElementById('note_autoseggestion').innerHTML = mtchitems;
                                    $('.auto-suggest-li').on('click', function (event) {
                                        var final_string = ckContent.substring(0, indx) + "@" + event.target.innerText.trim();
                                        evt.editor.setData(final_string);
                                        obj.setState({
                                            note: final_string,
                                        })

                                        document.getElementById('note_autoseggestion').innerHTML = "";
                                        evt.editor.focus();
                                    });
                                }
                            }
                        } else {
                            document.getElementById('note_autoseggestion').innerHTML = "";
                        }
                    }
                } else {
                    document.getElementById('note_autoseggestion').innerHTML = "";
                }
            }, 300);
        } else {
            evt.editor.focus();
        }
    }


    goBack() {
        window.history.back();
    }

    AddNote() {
        let errors = {};
        document.getElementById("add_note").innerHTML = "Sending....";
        const fd = new FormData;
        document.getElementById("add_note").disabled = true;
        fd.append('note', this.state.note);
        fd.append('transcript_id', this.props.match.params.transcript_id);
        fetch(this.state.apiUrl + '/ErRest/AddChatNote/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_note").disabled = false;
                document.getElementById("add_note").innerHTML = "Add Note";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        errors["note"] = "";
                        this.setState({ errors: errors, note: '' });
                        window.location.href = '/viewChat/' + this.props.match.params.transcript_id;
                    });
                } else {
                    errors["note"] = findresponse.msg;
                    this.setState({ errors: errors });
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    getChatDetails() {
        document.getElementById('loader-new').classList.remove("hidden");
        document.getElementById('intranet_body').classList.add("hidden");
        fetch(this.state.apiUrl + '/ErRest/viewChat/id/' + this.props.match.params.transcript_id + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                document.getElementById('loader-new').classList.add("hidden");
                document.getElementById('intranet_body').classList.remove("hidden");
                //console.log(responseJson);
                if (responseJson.error == 1) {
                    window.location.href = '/Unauthorized';
                } else {
                    this.setState({
                        chat_transcript: responseJson.chat_transcript,
                        formatted_owners: responseJson.formatted_owners,
                        owners: responseJson.owners,
                        notes: responseJson.notes,
                        note_history: responseJson.chat_history_table,
                        tags: responseJson.tags
                    })
                    var chat_details = $('#chat_details').val();
                    localStorage.setItem('chat_dtls', chat_details);
                }
            })
    }


    getHistoryDesc(type, old_value, new_value) {
        if (type == 2) {
            return ''
        } else if (type == 4) {
            return (
                <Link to={`/ChatHistoryRevision/${this.props.match.params.transcript_id}/noteId/${old_value}`} name={"max"} target="_blank"><span className="color-sky">View Revision</span></Link>
            )
        } else if (type == 3) {
            return 'Raw => Refined'
        } else if (type == 5) {
            return old_value+" => "+new_value
        } else if (type == 6) {
            return old_value+" => "+new_value
        }
    }


    NoteEditCondition(id, note) {
        return (
            <a href="javascript:void(0)" onClick={() => this.setNote(id, note)}> <i class="fa fa-edit"></i></a>
        )
    }

    setNote(id, note) {
        localStorage.setItem('ticket_note', note);
        this.props.history.push('/NoteChatEdit/' + id);
    }

    componentDidMount() {
        document.title = 'Chat Transcript';
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.getChatDetails();
    }
    getHistoryTitle(type, old_value, new_value) {
        if (type == 1) {
            return 'Chat Transcript Updated'
        } else if (type == 2) {
            return ('Note Added : ' + new_value)
        } else if (type == 4) {
            return ('Note Updated : ' + old_value)
        } else if (type == 3) {
             return ('Status Changed')
        } else if (type == 5) {
             return ('Visitor Name Changed')
        } else if (type == 6) {
             return ('Title Changed')
        }
    }

    render() {
        return (
            <div>
                <Header brecum_name="Chat Transcript" brecum_page="Chat Transcript" />
                <div class="right_col">
                    <div class="ticket_list">
                        <div class="loader-new" id="loader-new"></div>
                        <div className="intranet_body hidden" id="intranet_body">
                            <div class="title mob er_ids view_chats"><div class="er_id"><span class="er">View Chat Transcript:  </span><HeaderMob page_name={this.props.match.params.snippetId} /></div></div>
                            <div class="left-section btn-muvi pull-left">
                                    <Link to={`/EditChat/${this.props.match.params.transcript_id}`} name={"max"} className="btn btn-sky">Edit</Link>
                                    <button type="button" className="btn btn-blue hidden-sm" onClick={() => this.goBack()} >Back</button>
                                </div>
                            <div class="request_details er row margin_top_less">
                                <div class="col-xs-12">
                                    <div class="form-section chat-view-section">
                                        <div class="details_des">
                                                {
                                                    this.state.chat_transcript.map((chat_transcript, key) =>
                                                        <div class="chat_bar_view">
                                                            <div className={"visitor_name form-control text-inded"} >{chat_transcript.visitor_name}</div>
                                                            <input type ="hidden" value={chat_transcript.history_formated} id="chat_details" />
                                                            <div class="chat_transcript" dangerouslySetInnerHTML={{ __html: chat_transcript.history_formated }} />                                                        </div>
                                                    )
                                                }
                                        </div>
                                    </div>
                                    <div id='add_tags'>
                                                <h6>Tags: </h6>
                                    {
                                        this.state.tags.map((tags, key) =>
                                        <div class="already_added_tags">{tags.value ? tags.value : "--NA--"}</div>
                                         )
                                        }
                                    </div>
                                    <div class="request_details">
                                        <div id="exTab1">
                                            <ul class="nav nav-pills">
                                                <li class="active"><a href="#note" data-toggle="tab">Notes</a></li>
                                                <li><a href="#history" data-toggle="tab">History</a></li>
                                            </ul>
                                        </div>
                                        <div class="tab-content customer-tab clearfix">
                                            <div className="tab-pane active" id="note">
                                                <div class="row">
                                                    <div className="form-section ckeditor">
                                                        <CKEditor
                                                            activeClass="p10"
                                                            name='note'
                                                            content={this.state.note}
                                                            events={{
                                                                "change": this.ckOnChange1
                                                            }}
                                                        />
                                                        <div id='note_autoseggestion'></div>
                                                        <span class="error">{this.state.errors["note"]}</span>
                                                    </div>
                                                    <div className="form-section ckeditor">
                                                        <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.AddNote()}>Add Note</button>
                                                    </div>
                                                </div>
                                                <div className="feedback">
                                                    {this.state.notes.length > 0 ?
                                                        <h5 class="title"><span>View Note</span></h5>
                                                        : ''}
                                                    {
                                                        this.state.notes.map((data, key) =>
                                                            <div class="sub_feedback" id={'note' + data.id}>
                                                                <div class="main">
                                                                    <div class="pro_image">
                                                                        {this.state.formatted_owners[data.user_id].attachment_url ? <img src={this.state.formatted_owners[data.user_id].attachment_url + this.state.formatted_owners[data.user_id].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[data.user_id].img_name}</span>}
                                                                    </div>
                                                                    <div class="fa-icon tooltips">
                                                                        {this.NoteEditCondition(data.id, data.note)}
                                                                    </div>
                                                                    <h6>{data.owner_name}</h6>
                                                                    <span class="date">{data.created_date}</span>
                                                                </div>
                                                                <div class="sub">
                                                                    <a href={'#note' + data.id} key={key} to={data.id} name={'note' + data.id}><span>Note {data.id}</span></a>
                                                                    <div class="note_list" dangerouslySetInnerHTML={{ __html: data.note }} />
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div class="tickets tab-pane " id="history">
                                                <div className="feedback">
                                                    {this.state.note_history.length > 0 ?
                                                        <h5 class="title"><span>Chat Transcript History</span></h5>
                                                        : ''}
                                                    <ul class="tickets_head">
                                                        <li class="intra_col_25">Date</li>
                                                        <li class="intra_col_25">User</li>
                                                        <li class="intra_col_25">Field</li>
                                                        <li class="intra_col_25">Change</li>
                                                    </ul>
                                                    {
                                                        this.state.note_history.map((ErHistory, key) =>
                                                            <ul class="tickets_number">
                                                                <li class="intra_col_25">{ErHistory.created_date} </li>
                                                                <li class="intra_col_25">{this.state.formatted_owners[ErHistory.user_id].name}</li>
                                                                <li class="intra_col_25">{this.getHistoryTitle(ErHistory.type, ErHistory.old_value, ErHistory.new_value)}</li>
                                                                <li class="intra_col_25">{this.getHistoryDesc(ErHistory.type, ErHistory.old_value, ErHistory.new_value)}</li>
                                                            </ul>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
        );
    }
}
export default ViewChat;


// WEBPACK FOOTER //
// ./src/components/er/ViewChat.js